<template>
  <div class="followerInfoWrapper">
    <div class="followerInfoHeader">
      <div>번호</div>
      <div>이름</div>
      <div>성별</div>
      <div>나이</div>
      <div>직업</div>
      <div>지역</div>
      <div>팔로잉</div>
    </div>
    <div class="followerInfoContentDiv">
      <div class="followerInfoContent" v-for="(row, index) in tableData.rows" v-bind:key="row.id">
        <div>{{index + 1}}</div>
        <div>{{row.nickname}}</div>
        <div>{{row.gender}}</div>
        <div>{{row.age}}</div>
        <div>{{row.job}}</div>
        <div>{{row.location}}</div>
        <div>
          <img class="followerInfoIcon" v-bind:src="cancelIcon" v-on:click="setCancel(row.id)">
        </div>
      </div>
      <div class="followerInfoNoDataDiv" v-show="tableData.rows.length === 0">
        <span>팔로워가 없습니다.</span>
      </div>
    </div>
    <div class="followerInfoFooter">
      <div class="pagePreviousDiv">
        <img class="pagePreviousIcon" v-show="isShowPreviousPagePointer" v-on:click="setShowPages(-10)" v-bind:src="pagePreviousIcon" />
      </div>
      <span class="page" v-for="index in showPageArray" v-bind:key="index" v-bind:class="{selectedPage: contentPageIndex === index}" v-on:click="getSelectedPageData(index)">{{index + 1}}</span>
      <div class="pageNextDiv">
        <img class="pageNextIcon" v-show="isShowNextPagePointer" v-on:click="setShowPages(10)" v-bind:src="pageNextIcon" />
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
import params from '../../../params'

export default {
  data () {
    return {
      districtList: null,
      jobList: params.job,
      cancelIcon: '',
      tableData: {
        rows: []
      },
      contentPageIndex: 0,
      showPageArray: [],
      showPageArrayIndexStart: 0,
      isShowNextPagePointer: false,
      isShowPreviousPagePointer: false,
      totalPageNumber: 0,
      pagePreviousIcon: null,
      pageNextIcon: null
    }
  },
  methods: {
    setTableData: function (listData) {
      let rows = []
      for(var i = 0; i < listData.length; i++) {
        let gender
        if(listData[i].user.gender != null) {
          if (listData[i].user.gender === 'MALE') {
            gender = '남자'
          }else if (listData[i].user.gender === 'FEMALE') {
            gender = '여자'
          }else {
            gender = '성별모름'
          }
        }else {
          gender = '정보없음'
        }
        rows.push({
          id: listData[i].id,
          nickname: listData[i].user.nickname,
          gender: gender,
          age: listData[i].user.birthYear != null ? (new Date().getFullYear() + 1) - listData[i].user.birthYear + '세' : '정보없음',
          job: listData[i].user.job != null ? this.jobList.find(items => items.engText === listData[i].user.job).text : '정보없음',
          location: listData[i].user.districts.length !== 0 ? this.getLocationText(listData[i].user.districts) : '정보없음'
        })
      }
      this.tableData.rows = rows
    },
    setAllDistrictList: function (districtAllData) {
      this.districtList = JSON.parse(JSON.stringify(districtAllData))
    },
    getLocationText: function (districtIdList) {
      let locationText = ''
      for(var i = 0; i < districtIdList.length; i++) {
        let districtInfo = this.districtList.find(items => items.id === districtIdList[i])
        locationText += districtInfo.regionName + ' ' + districtInfo.name + ','
      }
      return locationText.substring(0, locationText.length - 1)
    },
    setPageInfo: function () {
      this.showPageArray = []
      if(this.totalPageNumber <= this.showPageArrayIndexStart + 10) {
        for (var i = this.showPageArrayIndexStart; i < this.totalPageNumber; i++) {
          this.showPageArray.push(i)
          this.isShowNextPagePointer = false
        }
      } else {
        // eslint-disable-next-line no-redeclare
        for (var i = this.showPageArrayIndexStart; i < this.showPageArrayIndexStart + 10; i++) {
          this.showPageArray.push(i)
        }
        this.isShowNextPagePointer = true
      }
      this.isShowPreviousPagePointer = this.showPageArrayIndexStart !== 0
    },
    getSelectedPageData: async function (selectedPageIndex) {
      this.contentPageIndex = selectedPageIndex
      try {
        let tableDataResponse = await store.dispatch('followerInfoApi', {pageIndex: selectedPageIndex})
        this.setTableData(tableDataResponse.data.data.content)
      } catch (error) {
        console.log(error.response)
      }
    },
    setShowPages: function (showPageNumber) {
      this.showPageArrayIndexStart += showPageNumber
      this.setPageInfo()
    },
    setCancel: async function (userId) {
      try {
        await store.dispatch('followerCancelApi', {userId: userId})
        // 데이터 제거
        let selectedData = this.tableData.rows.find(items => items.id === userId)
        let idx = this.tableData.rows.indexOf(selectedData)
        if (idx > -1) {
          this.tableData.rows.splice(idx, 1)
        }
      } catch (error) {
        console.log(error.response)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let tableDataResponse = await store.dispatch('followerInfoApi', {pageIndex: 0})
      next(vm => {
        vm.totalPageNumber = tableDataResponse.data.data.totalPages
        vm.setAllDistrictList(store.getters.getDistrictAllList)
        vm.setPageInfo(tableDataResponse.data.data)
        vm.setTableData(tableDataResponse.data.data.content)
      })
    }catch (error) {
      console.log(error.response)
    }
  },
  created: function () {
    this.cancelIcon = require('@/assets/img/follower_request_cancel_icon.png')
    this.pagePreviousIcon = require('@/assets/img/page_previous_icon.png')
    this.pageNextIcon = require('@/assets/img/page_next_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.followerInfoWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: auto;
  overflow-y: auto;
}

.followerInfoHeader{
  display : -webkit-flex;
  display : flex;
  color: rgb(0,153,255);
  font-size: 11px;
  padding: 0 32px;
}

.followerInfoContentDiv{
  overflow-y: auto;
  flex: 1;
}

.followerInfoContent{
  display : -webkit-flex;
  display : flex;
  padding: 0 32px;
  font-size: 11px;
}

.followerInfoHeader > div:first-child, .followerInfoContent >  div:first-child{
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 63px;
  border-bottom: rgb(172,172,172) solid 1px;
}


.followerInfoHeader > div:nth-child(2), .followerInfoContent >  div:nth-child(2){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 71px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoHeader > div:nth-child(3), .followerInfoContent >  div:nth-child(3){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 71px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoHeader > div:nth-child(4), .followerInfoContent >  div:nth-child(4){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 71px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoHeader > div:nth-child(5), .followerInfoContent >  div:nth-child(5){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 93px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoHeader > div:nth-child(6), .followerInfoContent >  div:nth-child(6){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  flex: auto;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoHeader > div:last-child{
  text-align: center;
  vertical-align: middle;
  padding: 15px 0;
  width: 66px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoContent > div:last-child{
  display : -webkit-flex;
  display : flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  padding: 0;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerInfoFooter {
  text-align: center;
}

.pagePreviousDiv, .pageNextDiv {
  display: inline;
  vertical-align: middle;
}

.pagePreviousIcon, .pageNextIcon {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.page {
  cursor: pointer;
  text-decoration: underline;
  padding: 0 5px;
}

.selectedPage {
  font-weight: bold;
}

.followerInfoIcon{
  cursor: pointer;
  margin: 0 5px;
  height: 28px;
  width: auto;
}

.followerInfoNoDataDiv {
  text-align: center;
  height: 100px;
  font-size: 11px;
  padding-top: 60px;
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/followerInfo.vue